"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const products_1 = require("@/services/products");
const products_2 = require("@/store/ducks/products");
function editProductUseCase(productId, productName) {
    return async (dispatch) => {
        dispatch((0, products_2.updateProduct)());
        try {
            await (0, products_1.updateProductService)(productId, productName);
            dispatch((0, products_2.updateProductSuccess)());
            dispatch((0, products_2.openProductsToast)({
                status: "success",
                message: "Product edited successfully",
            }));
            dispatch((0, products_2.onHideSavePrompt)());
        }
        catch (error) {
            dispatch((0, products_2.updateProductError)());
            dispatch((0, products_2.openProductsToast)({
                status: "error",
                message: "Error editing product.",
            }));
        }
    };
}
exports.default = editProductUseCase;
